import src from "IMAGE";
export default { src, width: 1973, height: 325, blurWidth: 0, blurHeight: 0};
